export default __webpack_public_path__ + "static/media/document.834104ed.svg";